import get from 'lodash/get';
import { DISCOUNT_QUERY_PARAM } from 'src/common/constants/queryParams';
import { trialUnitTypes } from '../../constants/subscription/coupon';
import parse from '../../utils/queryString/parse';

export const isMonthlyTrial = (product) =>
  !!product.discountFreeTrialUnit &&
  product.discountFreeTrialUnit === trialUnitTypes.month;

// calculates milliseconds based on num of days provided
export const getMsForDays = (days = 0) => 1000 * 60 * 60 * 24 * days; // milliseconds, seconds, minutes, hours, days

// is discounted using url param discount=true
export const isDiscountEnabled = (location) => {
  // Parse the query directly from the search string since
  // this utility may be used within top level route components
  // where the query object is not available on the client. See
  // this ticket, TUNE-10780, for details.
  const query = parse(get(location, 'search', ''));
  return get(query, DISCOUNT_QUERY_PARAM) === 'true';
};
